import React from 'react'
import { useApp } from '../../context/AppContext';
import toast from 'react-hot-toast';

function SideBar({currentTab, setCurrentTab}) {
    const { logout} = useApp()
    const tabs = ['Overview', 'Properties', 'Bookings', 'Logout'];
    return (
        <div className="sticky top-3 border rounded-lg overflow-hidden">
            {tabs.map((tab, index) => (
                <div
                    key={tab}
                    onClick={() => {
                        if (tab === 'Logout') {
                            logout()
                            setTimeout(() => {
                                toast.success('Logout Successfull')
                            }, 500)
                        } else {
                            setCurrentTab(index);
                        }
                    }}
                    className={`text-pretty text-center py-4 cursor-pointer transition-colors ${currentTab === index
                            ? 'bg-primary/10 text-primary font-medium'
                            : 'hover:bg-gray-200/45'
                        }`}
                >
                    {tab}
                </div>
            ))}
        </div>
    );
}

export default SideBar